import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";

import { dataAutomation } from "./dataAutomation";
import * as SC from "./styles";
import { VIEWER_MODE_BANNER } from "./text";

type ViewerBannerSchema = { isViewerMode: boolean };

export const ViewerModeBanner = ({ isViewerMode }: ViewerBannerSchema) => {
    return isViewerMode ? (
        <SC.ViewerBannerContainer data-automation={dataAutomation.container}>
            <SWReactIcons
                iconName="ic-monitor"
                size="lg"
            />
            <div>{translate(VIEWER_MODE_BANNER)}</div>
        </SC.ViewerBannerContainer>
    ) : null;
};
